import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as licenseReducer from './license.reducer';

export const selectLicenseSlice = createFeatureSelector<licenseReducer.State>(
    licenseReducer.LicenseStore
);

export const getLicenseSlice = createSelector(
    selectLicenseSlice,
    (state) => state
);

export const getLicenseIsLoading = () =>
    createSelector(
        getLicenseSlice,
        (state: licenseReducer.State) => state?.license?.isLoadingSingle
    );

export const getLicenseHasLoadingError = () =>
    createSelector(
        getLicenseSlice,
        (state: licenseReducer.State) => state?.license?.hasLoadingSingleError
    );

export const getLicense = () =>
    createSelector(
        getLicenseSlice,
        (state: licenseReducer.State) => state?.license?.single
    );
